import { render, staticRenderFns } from "./ModalOpcionaisEscolha.vue?vue&type=template&id=9a56671e&scoped=true&"
import script from "./ModalOpcionaisEscolha.vue?vue&type=script&lang=js&"
export * from "./ModalOpcionaisEscolha.vue?vue&type=script&lang=js&"
import style0 from "./ModalOpcionaisEscolha.vue?vue&type=style&index=0&id=9a56671e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a56671e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VCard,VCardActions,VCardTitle,VCheckbox,VDialog,VRadio,VRadioGroup})
